<div class="retriever-form-host">
  <app-simulation-form-shell [loading]="loading">

      <div class="left-column" simulation-left>
        <div class="header-left">
          <button class="back-button" (click)="goBack()" [title]="'BUTTON.BACK' | translate">
            <fa-icon [icon]="icons.faArrowLeft"></fa-icon>
          </button>
          <div class="retriever-name">{{ form.name || ('RETRIEVERS.FIELDS.NAME_PLACEHOLDER' | translate) }}</div>
        </div>

        <div class="panel-card config-card">
          <div class="config-card-header">
            <div class="config-card-title">
              <span class="config-card-icon"><fa-icon [icon]="icons.faCog"></fa-icon></span>
              <div>
                <h2 class="panel-title">{{ 'RETRIEVERS.SECTIONS.CONFIG' | translate }}</h2>
                <p>{{ 'RETRIEVERS.SECTIONS.CONFIG_HINT' | translate }}</p>
              </div>
            </div>
          </div>

        <div class="config-fields-grid">

        <div class="field-group field-group--wide">
          <label class="field-label">{{ 'RETRIEVERS.FIELDS.CONTENT' | translate }} <span class="required">*</span></label>
          <textarea
            class="field-textarea"
            rows="4"
            [(ngModel)]="form.content"
            [placeholder]="'RETRIEVERS.FIELDS.CONTENT_PLACEHOLDER' | translate">
          </textarea>
        </div>

        @if (showTopK) {
        <div class="field-group field-group--compact">
          <label class="field-label">{{ 'RETRIEVERS.FIELDS.TOP_K' | translate }}</label>
          <input
            type="number"
            class="field-input field-input--sm"
            [(ngModel)]="form.top_k"
            min="1"
            step="1"
            placeholder="—" />
        </div>
        }

        @if (showLlmModel) {
        <div class="field-group">
          <label class="field-label">{{ 'RETRIEVERS.FIELDS.LLM_MODEL' | translate }} <span class="required">*</span></label>
          <ng-select
            [items]="llmModelOptions"
            bindLabel="display_label"
            bindValue="key"
            [(ngModel)]="form.llm_model"
            [clearable]="false"
            [searchable]="true"
            appendTo="body"
            [placeholder]="'RETRIEVERS.FIELDS.LLM_MODEL' | translate"
            class="retriever-select">
          </ng-select>
        </div>
        }

        <div class="field-group">
          <label class="field-label">{{ 'RETRIEVERS.FIELDS.RETRIEVER' | translate }} <span class="required">*</span></label>
          <ng-select
            [items]="retrieverOptions"
            bindLabel="display_label"
            bindValue="key"
            [(ngModel)]="form.retriever"
            [clearable]="false"
            [searchable]="true"
            appendTo="body"
            [placeholder]="'RETRIEVERS.FIELDS.RETRIEVER' | translate"
            class="retriever-select">
          </ng-select>
        </div>

        @if (delfosServerConfigs.length > 1) {
          <div class="field-group">
            <label class="field-label">{{ 'RETRIEVERS.FIELDS.DELFOS_SERVER' | translate }}</label>
            <ng-select
              [items]="delfosServerConfigs"
              bindLabel="display_label"
              bindValue="id"
              [(ngModel)]="form.delfos_server_config_id"
              [clearable]="true"
              [searchable]="false"
              appendTo="body"
              [placeholder]="'INTERACTIONS.CONFIG.SELECT_OPTION' | translate"
              [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate"
              class="retriever-select">
            </ng-select>
          </div>
        }

        <div class="field-group field-group--wide">
          <label class="field-label">{{ 'RETRIEVERS.FIELDS.KNOWLEDGE' | translate }} <span class="required">*</span></label>
          <div class="knowledge-row">
            <ng-select
              [items]="knowledgeOptions"
              bindLabel="name"
              bindValue="name"
              [(ngModel)]="form.knowledge"
              [clearable]="false"
              [searchable]="true"
              appendTo="body"
              [placeholder]="'RETRIEVERS.FIELDS.KNOWLEDGE' | translate"
              class="retriever-select">
              <ng-template ng-label-tmp let-item="item">
                <span>{{ item.name }}</span>
                @if (item.container_name) {
                <span class="kb-container-tag">{{ item.container_name }}</span>
                }
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <span>{{ item.name }}</span>
                @if (item.container_name) {
                <span class="kb-container-tag">{{ item.container_name }}</span>
                }
              </ng-template>
            </ng-select>
            @if (isAdmin) {
              <button type="button" class="kb-new-btn" (click)="openSelectArchiveKb()"
                [title]="'KNOWLEDGE_BASE.NEW_FROM_FILE' | translate">
                <fa-icon [icon]="icons.faPlus"></fa-icon>
              </button>
            }
          </div>
        </div>

        <div class="field-group field-group--inline field-group--wide">
          <label class="field-label">{{ 'RETRIEVERS.FIELDS.OVERWRITE_CACHE' | translate }}</label>
          <label class="toggle-switch">
            <input type="checkbox" [(ngModel)]="form.overwrite_cache" />
            <span class="toggle-track"></span>
          </label>
        </div>
        </div>
        </div>
      </div>

      <div class="right-column" simulation-right>
        <div class="panel-card extraction-card">
        <app-tabs [tabs]="extractionTabs" [(activeId)]="activeTab" variant="underline" [fullWidth]="true"></app-tabs>

        <div class="tab-panels">
        <div class="tab-panel tab-panel--form" [hidden]="activeTab !== 'form'">
          <div class="retriever-form-sections">
            <app-tabs [tabs]="instructionTabs" activeId="instructions"
              variant="underline" [fullWidth]="true">
            </app-tabs>

            <div class="retriever-form-tab">
              @if (showInstructions) {
                <div class="field-group">
                  <label class="field-label">{{ 'RETRIEVERS.FIELDS.INSTRUCTIONS' | translate }} <span class="required">*</span></label>
                  <textarea class="field-textarea" rows="5" [(ngModel)]="form.instructions"
                    [placeholder]="'RETRIEVERS.FIELDS.INSTRUCTIONS_PLACEHOLDER' | translate">
                  </textarea>
                </div>
              }

              @if (showSearchColumns) {
                <div class="field-group">
                  <label class="field-label">{{ 'RETRIEVERS.FIELDS.SEARCH_COLUMNS' | translate }}</label>
                  <div class="chips-input">
                    @for (col of form.search_columns; track $index) {
                      <span class="chip">
                        <span class="chip-text">{{ col }}</span>
                        <button type="button" class="chip-remove" (click)="removeSearchColumn($index)"
                          [title]="'BUTTON.DELETE' | translate">
                          <fa-icon [icon]="icons.faTimes"></fa-icon>
                        </button>
                      </span>
                    }
                    <input type="text" class="chip-draft" [(ngModel)]="searchColumnDraft"
                      (keydown.enter)="$event.preventDefault(); addSearchColumn(searchColumnDraft)"
                      (blur)="addSearchColumn(searchColumnDraft)"
                      [placeholder]="'RETRIEVERS.FIELDS.SEARCH_COLUMNS_PLACEHOLDER' | translate" />
                  </div>
                </div>
              }
            </div>

            <app-tabs [tabs]="fieldTabs" activeId="fields"
              variant="underline" [fullWidth]="true">
            </app-tabs>

            <div class="retriever-form-tab">
              @if (showUserList) {
                <app-models-form [formType]="'desired'" [initialValue]="userListInitial" [showSaveFormatOption]="false"
                  (valueChange)="onUserListChange($event)">
                </app-models-form>
              }
            </div>
          </div>

        <app-simulation-model-actions
          [(modelName)]="form.name"
          nameLabelKey="RETRIEVERS.FIELDS.NAME"
          namePlaceholderKey="RETRIEVERS.FIELDS.NAME_PLACEHOLDER"
          [saveLabelKey]="isEditing ? 'BUTTON.SAVE' : 'BUTTON.CREATE'"
          executeLabelKey="RETRIEVERS.EXECUTE.BUTTON"
          [showExecute]="isEditing"
          [saveDisabled]="!canSave"
          [executeDisabled]="executing"
          [saving]="saving"
          [executing]="executing"
          (save)="save()"
          (execute)="execute()">
        </app-simulation-model-actions>

        </div>

        <div class="tab-panel" [hidden]="activeTab !== 'result'">
          <app-simulation-executions-list
            [simulationId]="route.snapshot.paramMap.get('id') || ''"
            simulationType="retriever"
            [executions]="executions"
            [loading]="executing">
          </app-simulation-executions-list>
        </div>

        </div>
      </div>

      </div>
  </app-simulation-form-shell>

  <app-modal-select-archive-kb
    [show]="showSelectArchiveKb"
    (close)="showSelectArchiveKb = false"
    (selected)="onArchiveSelectedForKb($event)">
  </app-modal-select-archive-kb>

  <app-modal-deploy-knowledge-base
    [show]="showDeployKb"
    [archive]="selectedArchiveForKb"
    (close)="showDeployKb = false"
    (deployed)="onKbDeployed($event)">
  </app-modal-deploy-knowledge-base>

  <app-modal-confirm [show]="showLeaveModal" title="COMMON.UNSAVED_TITLE" message="COMMON.UNSAVED_MESSAGE"
    confirmLabel="COMMON.LEAVE" variant="warning" btnVariant="danger" (close)="onLeaveCancel()"
    (confirm)="onLeaveConfirm()">
  </app-modal-confirm>

</div>
